import * as React from 'react';
import { SVGProps } from 'react';

const SvgEmergentPatientTransfer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="M15.385 26.358v-4.28l17.21-.018 4.258 4.26-21.468.038Z"
    />
    <path
      fill="currentColor"
      d="M11.13 24.158a2.15 2.15 0 0 0-2.187-2.15h-1.08a2.15 2.15 0 0 0-2.148 2.189 2.149 2.149 0 0 0 2.188 2.149H8.98a2.15 2.15 0 0 0 2.15-2.188"
    />
    <path
      fill="currentColor"
      d="M15.385 22.06h-2.187a2.149 2.149 0 0 0-2.115 2.15 2.149 2.149 0 0 0 2.149 2.118h2.149m4.302-20.703-6.077 6.077 6.077 6.078 6.078-6.078-6.078-6.077Zm1.075 10.113h-2.15v-1.74h2.15v1.74Zm-2.15-2.914V7.667h2.15v5.157h-2.15Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M3.75 20v15M35 27.25H3.75M35 31H3.75m32-4.5V35"
    />
  </svg>
);

export default SvgEmergentPatientTransfer;
